import { AppColors } from "@/styles/colors";
import {
  Box,
  Checkbox,
  CheckboxCheckedChangeDetails,
  Table,
  Text,
} from "@chakra-ui/react";

interface Props {
  userRoles?: { id: number; nombre: string }[];
  roleSelection: number[];
  setRoleSelection: (value: number[]) => void;
}

export const UserRolesTable = ({
  userRoles,
  roleSelection,
  setRoleSelection,
}: Props) => {
  const handleRoleSelection = (
    changes: CheckboxCheckedChangeDetails,
    role: { id: number; nombre: string },
  ) => {
    let currentSelection = roleSelection ?? [];
    setRoleSelection?.(
      changes?.checked
        ? [...currentSelection, role.id]
        : roleSelection?.filter((id) => id !== role.id),
    );
  };

  return (
    <Box>
      <Table.ScrollArea
        css={{
          "@media (max-width: 1350px) and (min-width: 1272px)": {
            height: "240px",
          },
          "@media (max-width: 1414px) and (min-width: 1351px)": {
            height: "310px",
          },
          "@media (max-width: 1590px) and (min-width: 1415px)": {
            height: "390px",
          },
          "@media (max-width: 1696px) and (min-width: 1591px)": {
            height: "440px",
          },
          "@media (max-width: 1900px)": {
            height: "490px",
          },
          "@media (min-width: 1901px)": {
            height: "490px",
          },
        }}
        borderRadius="8px"
      >
        <Table.Root
          interactive
          striped
          size="sm"
          borderRadius="8px"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          stickyHeader
          css={{
            "& thead": {
              zIndex: 1,
            },
          }}
        >
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeader>
                <Text
                  padding="16px"
                  color={AppColors.GRAY_TEXT}
                  fontWeight={700}
                  textTransform="uppercase"
                  fontSize="12px"
                >
                  Funcionalidad
                </Text>
              </Table.ColumnHeader>
              <Table.ColumnHeader>
                <Text
                  padding="16px"
                  color={AppColors.GRAY_TEXT}
                  fontWeight={700}
                  textTransform="uppercase"
                  fontSize="12px"
                >
                  Seleccione
                </Text>
              </Table.ColumnHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {userRoles?.map((role) => (
              <Table.Row key={role?.id}>
                <Table.Cell>
                  <Text
                    padding="16px"
                    fontWeight={400}
                    fontSize="12px"
                    color={AppColors.BLACK_TEXT_SECONDARY}
                  >
                    {role?.nombre}
                  </Text>
                </Table.Cell>
                <Table.Cell>
                  <Checkbox.Root
                    top="1"
                    paddingLeft={3}
                    aria-label="Select row"
                    checked={roleSelection?.includes(role?.id)}
                    onCheckedChange={(changes) =>
                      handleRoleSelection(changes, role)
                    }
                  >
                    <Checkbox.HiddenInput />
                    <Checkbox.Control borderColor={AppColors.GRAY_BORDER_1} />
                  </Checkbox.Root>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Root>
      </Table.ScrollArea>
    </Box>
  );
};
